Pegasus.AutoCenterMixin = Ember.Mixin.create({
  didInsertElement: function(){
    this._super();
    Em.run.scheduleOnce('afterRender', this, this.get('position') );
    this.bindResize();
  },
  willDestroyElement: function(){
    this._super();
    this.unbindResize();
  },
  bindResize: function(){
    var position = this.get( 'position' );
    $( window ).bind('resize.' + this.get('elementId'), position );
  },
  unbindResize: function(){
    $( window ).unbind('resize.' + this.get( 'elementId' ) );
  },
  position: Ember.computed( function () {
    var definedWidth = this.get('width') || 'auto',
      positioner = (function( object ){
        return function(){
          if( !object ){
            return;
          }

          var top = 0,
              left = 0,
              $box = object.$(),
              scrollTop,
              scrollLeft,
              $window = $( window ),
              speed = 0,
              loadedHeight,
              loadedWidth,
              windowWidth = $window.width(),
              windowHeight = $window.height(),
              originalDisplay = $box.css('display');

          // remove the modal so that it doesn't influence the document width/height
          $box.css({
            top: -9e4,
            left: -9e4,
            width: definedWidth,
            display: 'block',
            position: 'absolute'
          });

          //Take into account scroll positions
          scrollTop = $window.scrollTop();
          scrollLeft = $window.scrollLeft();

          top = scrollTop;
          left = scrollLeft;

          loadedHeight = $box.height();
          loadedWidth = $box.width();

          left += ( windowWidth / 2 );
          left -= ( loadedWidth / 2 );

          top += ( windowHeight / 2 );
          top -= ( loadedHeight / 2 );
          top -= 20; // this just looks slightly better

          $box.css({ top: top,
                    left: left,
                 display: originalDisplay,
                   width: definedWidth });
        };

      })( this );

    return positioner;
  }).volatile()
});
